import { shade, rgba } from "polished";
import authentication from "@irati/auth";
import { shadows } from "./elevation";
import maxWidthMedia, { minWidthMedia } from "./media";
import { updateLegacyBrand } from "./colors";
// Colors that are manipulated / used multiple times in theme
var perkboxBlue = "#00ADEE";
var darkGrey = "#3D3D36";
var SHADE_MODIFIER = 0.8;
var HOVER_MODIFIER = 0.5;
var DARK_MODIFIER = 0.2;
var SHADOW_MODIFIER = 0.17;
var dropShadowGrey = rgba(darkGrey, SHADOW_MODIFIER);
export var makeBrand = function (tenant) {
    if (tenant === void 0) { tenant = authentication.userTenant(); }
    var brandColor = tenant.settings.color;
    return {
        default: brandColor,
        shade: "" + shade(0.8, brandColor),
        dark: "" + shade(0.2, brandColor),
        hover: "" + shade(0.5, brandColor)
    };
};
export var updateBrand = function (tenant) {
    var _a = makeBrand(tenant), defaultColor = _a.default, shadeColor = _a.shade, dark = _a.dark, hover = _a.hover;
    var brand = {
        default: defaultColor,
        shade: shadeColor,
        dark: dark,
        hover: hover
    };
    mainTheme.colors.brand = brand;
    updateLegacyBrand(brand);
};
var mainTheme = {
    // New colors should be confirmed with UI/UX and FE before adding to global styling
    colors: {
        success: "#00BDB3",
        error: "#B30000",
        fontColor: darkGrey,
        tooltip: "#1EBCB2",
        brand: {
            default: perkboxBlue,
            shade: "" + shade(SHADE_MODIFIER, perkboxBlue),
            dark: "" + shade(DARK_MODIFIER, perkboxBlue),
            hover: "" + shade(HOVER_MODIFIER, perkboxBlue)
        },
        perkbox: {
            blue: perkboxBlue,
            darkBlue: "#00678E",
            greenBlue: "#21A0A0"
        },
        products: {
            insights: "#21A0A0",
            medical: "#1EBCB2",
            perks: perkboxBlue,
            recognition: "#EE6352"
        },
        greys: {
            white: "#FFFFFF",
            lightest: "#F7F7F7",
            graphGrey: "#EFEFEF",
            light: "#E0E0E0",
            mediumLight: "#C5C5C5",
            medium: "#AAAAAA",
            mediumDark: "#666565",
            dark: darkGrey,
            black: "#000000",
            disabled: "#E9E9E9",
            disabledText: "#888888",
            dropShadowGrey: dropShadowGrey
        },
        callToAction: {
            default: "#FAD600",
            hover: "#F8DF4A",
            pressed: "#DFBB33"
        },
        border: {
            greyPrimary: "#D0AB3D",
            greySecondary: "#D0AB3D"
        }
    },
    mediaQueries: {
        maxWidthMedia: maxWidthMedia,
        minWidthMedia: minWidthMedia
    },
    colorFunctions: {
        rgba: rgba,
        shade: shade
    },
    shadows: shadows
};
export default mainTheme;
